var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpeedometer(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 51.925,
    height: 51.927,
    viewBox: "0 0 51.925 51.927",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a,.b{fill:#fff;}.b{fill-rule:evenodd;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0.003 0.004)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M21.464,2a1.622,1.622,0,0,1,1.622,1.622V8.488a1.622,1.622,0,1,1-3.244,0V3.622A1.622,1.622,0,0,1,21.464,2ZM7.619,7.619a1.622,1.622,0,0,1,2.293,0l2.968,2.965a1.624,1.624,0,0,1-2.3,2.3L7.619,9.912a1.622,1.622,0,0,1,0-2.293ZM2,21.464a1.622,1.622,0,0,1,1.622-1.622H8.767a1.622,1.622,0,1,1,0,3.244H3.622A1.622,1.622,0,0,1,2,21.464Zm30.818,0a1.622,1.622,0,0,1,1.622-1.622h4.866a1.622,1.622,0,0,1,0,3.244H34.44A1.622,1.622,0,0,1,32.818,21.464ZM35.264,7.69a1.262,1.262,0,0,0-1.71-.065l-13.56,11.6a2.952,2.952,0,1,0,4.227,4.084L35.361,9.37a1.262,1.262,0,0,0-.094-1.68Z",
    transform: "translate(4.495 4.496)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M21.625,51.551A25.958,25.958,0,1,1,51.553,30.294,25.958,25.958,0,0,1,21.625,51.551ZM6.492,37.657a38.975,38.975,0,0,1,38.934,0,22.708,22.708,0,1,0-38.934,0Z",
    transform: "translate(0 0)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpeedometer);
export default __webpack_public_path__ + "static/media/speedometer.617c3b568614ed591b2e67e5551f7372.svg";
export { ForwardRef as ReactComponent };